import { render, staticRenderFns } from "./PromoViewGamesBlacklistDialog.vue?vue&type=template&id=eb5e2268&scoped=true&lang=pug"
import script from "./PromoViewGamesBlacklistDialog.vue?vue&type=script&lang=ts"
export * from "./PromoViewGamesBlacklistDialog.vue?vue&type=script&lang=ts"
import style0 from "./PromoViewGamesBlacklistDialog.vue?vue&type=style&index=0&id=eb5e2268&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eb5e2268",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VIcon,VSelect,VTextField})
